import { useMemo } from "react";
import type { UseApiLoaderResponse } from "../../../server/api/hooks/use-api-loader";
import { useMultiformat } from "./use-multi-format";

export function useContentTypeMultipage(
  contentType: string | null | undefined,
): UseApiLoaderResponse<boolean> {
  const multiformat = useMultiformat();

  const multipageValue = useMemo(() => {
    if (!multiformat.data || !contentType) return false;

    const config = (multiformat.data.content_types || []).find((c) => c.name === contentType);

    return config?.multipage ?? false;
  }, [multiformat.data, contentType]);

  return multiformat.loading || multiformat.error
    ? multiformat
    : {
        ...multiformat,
        data: multipageValue,
      };
}
